module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.errorsExist) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible em-12",
    attrs: {
      "role": "alert"
    }
  }, _vm._l((_vm.form_errors), function(form_error) {
    return _c('div', [_vm._v("\n      " + _vm._s(form_error) + "\n    ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.form_status) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    " + _vm._s(_vm.form_status) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.messagesExist) ? _c('div', {
    staticClass: "alert alert-info"
  }, _vm._l((_vm.form_messages), function(form_message) {
    return _c('div', [_vm._v("\n      " + _vm._s(form_message) + "\n    ")])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c7e7e2d4!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/app-message-list.vue
// module id = vpmt
// module chunks = 0